// extracted by mini-css-extract-plugin
export default {"hotspotLayer":"_3WqBaLCYbnU_M9KuvuJiXF width-100 position-relative","annotationMode":"_3Zzm7fvv6aSPdUZp-SH1EX cusror-crosshair"};